export default function CommonMistakes() {
  const mistakes = [
    { icon: 'ri-file-copy-line', title: 'Отвечают шаблонами', desc: 'Клиенты мгновенно распознают скопированные сообщения. Шаблон убивает доверие и желание продолжать диалог.' },
    { icon: 'ri-article-line', title: 'Пишут слишком длинные сообщения', desc: 'Огромные простыни текста никто не читает. В переписке работают короткие, ёмкие сообщения.' },
    { icon: 'ri-question-answer-line', title: 'Задают по одному вопросу', desc: 'Растягивают диалог на часы вместо того, чтобы собрать информацию за 2–3 сообщения.' },
    { icon: 'ri-file-text-line', title: 'Сразу отправляют КП', desc: 'Коммерческое предложение без выявления потребностей — гарантированный способ потерять клиента.' },
    { icon: 'ri-compass-discover-line', title: 'Не управляют диалогом', desc: 'Плывут по течению, отвечают на вопросы клиента и не ведут его к следующему шагу.' },
    { icon: 'ri-door-lock-line', title: 'Боятся закрывать клиента', desc: 'Обсуждают детали бесконечно, но не переводят разговор в звонок, встречу или оплату.' },
    { icon: 'ri-user-unfollow-line', title: 'Теряют инициативу', desc: 'Ждут ответа клиента вместо того, чтобы предлагать варианты и управлять процессом.' },
    { icon: 'ri-pencil-ruler-line', title: 'Пишут канцелярским языком', desc: 'Формальный, сухой стиль разрушает доверие. Переписка — это разговор, а не документ.' },
    { icon: 'ri-emotion-line', title: 'Не работают с эмоциями', desc: 'Игнорируют настроение клиента, не проявляют эмпатию, не выстраивают человеческий контакт.' },
    { icon: 'ri-price-tag-3-line', title: 'Не продают ценность', desc: 'Говорят о характеристиках продукта вместо того, чтобы показать выгоду для клиента.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Переходят в скидки', desc: 'При первом же возражении предлагают скидку вместо аргументации ценности.' },
    { icon: 'ri-ghost-line', title: 'Исчезают после КП', desc: 'Отправили предложение и пропали. Нет follow-up, нет уточнений, нет сопровождения сделки.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-error-warning-line"></i>
            Типичные ошибки
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие ошибки совершают менеджеры в переписке
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Большинство менеджеров обучены продавать по телефону или на встречах. Когда они переносят те же техники в переписку — происходят эти ошибки.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-red-100 hover:bg-red-50/20 transition-colors group">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-red-100/50 transition-colors">
                <i className={`${item.icon} text-red-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}